import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { IVisitReviewReplyTokenCheckInfo } from '@app/visit-reviews/models';
import { VisitReviewsService } from '@app/visit-reviews/services/visit-reviews.service';
import { Observable, EMPTY, catchError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ReviewReplyTokenResolver implements Resolve<IVisitReviewReplyTokenCheckInfo> {

  constructor(
    private visitReviewService: VisitReviewsService,
    private router: Router) { }

  resolve(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<IVisitReviewReplyTokenCheckInfo> {
    const token = route.paramMap.get('reviewReplyToken');
    return this.visitReviewService.checkReviewReplyToken(token)
      .pipe(
        catchError(() => {
          this.router.navigate(['/']);
          return EMPTY;
        }));
  }

}
